function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { getIsObjectEmpty } from "./utils/getIsObjectEmpty";
export var some = function some(collection, predicate) {
  var isObject = _typeof(collection) === 'object' && collection !== null;

  if (isObject && getIsObjectEmpty(collection)) {
    return false;
  }

  if (isObject && predicate !== undefined) {
    return Object.keys(collection).some(function (key) {
      return predicate(collection[key]);
    });
  }

  return !!collection;
};